import {
  parse as queryStringParse,
  stringify as queryStringStringify,
} from 'query-string';

import { get } from 'lodash-es';

let queryParams = {};

if (window.__INITIAL_STATE__) {
  queryParams = get(JSON.parse(window.__INITIAL_STATE__), 'queryParams');
}

export const getQueryStringParsed = (path) => {
  return queryStringParse(path);
};

export const getQueryStringStringified = (queryStringObj) => {
  return queryStringStringify(queryStringObj);
};

export const getAllQueryStringPresent = () => {
  return queryStringStringify(queryParams);
};
